'use client';
import { FC, PropsWithChildren, useEffect } from 'react';
import cx from 'classnames';
import { CatHeader } from '@blocks-react/components/Header';
import { useInAppSignOut } from '../../hooks/useInAppSignOut';
import styles from './Header.module.scss';

export const HeaderContainer: FC<
  PropsWithChildren<{
    id?: string;
    className?: string;
    isStickyHeaderEnabled: boolean;
    isLoggedIn?: boolean;
  }>
> = ({
  children,
  id,
  className,
  isStickyHeaderEnabled,
  isLoggedIn = false
}) => {
  const { setInAppCookie } = useInAppSignOut();

  useEffect(() => {
    if (isLoggedIn) {
      setInAppCookie(isLoggedIn);
    }
  }, [isLoggedIn, setInAppCookie]);

  return (
    <CatHeader
      id={`${cx(id)}`}
      className={`${cx(className)} ${isStickyHeaderEnabled ? styles['header--sticky'] : ''} ${styles['header--fallback']} `}
    >
      <div className="w-100 d-print-none">{children}</div>
    </CatHeader>
  );
};
